var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Israel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M24,4c-4.492,0-8.625,1.499-11.964,4h23.927C32.625,5.499,28.492,4,24,4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M44,24c0-4.509-1.51-8.655-4.027-12H8.027C5.51,15.345,4,19.491,4,24c0,4.509,1.51,8.655,4.027,12 h31.946C42.49,32.655,44,28.509,44,24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M12.036,40c3.339,2.501,7.471,4,11.964,4s8.625-1.499,11.964-4H12.036z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M39.973,36H8.027c1.141,1.517,2.49,2.862,4.009,4h23.927C37.483,38.862,38.831,37.517,39.973,36z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M35.964,8H12.036c-1.519,1.138-2.868,2.483-4.009,4h31.946C38.831,10.483,37.483,9.138,35.964,8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M17.008,28h4.668l1.461,2.504L24,31.984l0.863-1.48L26.324,28h4.668l-0.879-1.504L28.656,24 l1.457-2.496L30.992,20h-4.668l-1.461-2.504L24,16.016l-0.863,1.48L21.676,20h-4.668l0.879,1.504L19.344,24l-1.457,2.496L17.008,28z M24,30l-1.168-2h2.332L24,30z M22.25,27l-1.75-3l1.75-3h3.5l1.75,3l-1.75,3H22.25z M29.25,27h-2.344l1.172-2.008L29.25,27z M29.25,21l-1.172,2.008L26.906,21H29.25z M24,18l1.168,2h-2.332L24,18z M18.75,21h2.344l-1.172,2.008L18.75,21z M19.922,24.992 L21.094,27H18.75L19.922,24.992z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Israel);
export default __webpack_public_path__ + "static/media/icons8-israel.1a88bac287313b9d5d1850f9c206a977.svg";
export { ForwardRef as ReactComponent };